import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanLoad,
  Route
} from '@angular/router';
import { Observable } from 'rxjs';
import { PrincipalService } from '../authentication/principal.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private principalService: PrincipalService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'JSESSIONID=; Path=/api/authentication; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //console.log('auth.guard - can activate - cookie: ', document.cookie);

    // Pasamos un array de las authorities posibles del usuario
    const authorities = route.data['requiredAuthorities'];

    if (this.principalService.isAuthenticated()) {
      if (!authorities || authorities.length === 0) {
        return true;
      } else if (this.principalService.hasAnyAuthorityCheck(authorities)) {
        return true;
      }
    }
    if(window.location.pathname.indexOf('/callbackSaml') === 0 ) 
    {
      //console.log('auth.guard - /callbackSaml en pathname');
      return this.router.navigate(['/callbackSaml']);
    } else {
      //console.log('auth.guard - NO /callbackSaml en pathname');
    }
    
    //console.log('auth.guard - samlLoginUrl: ' + environment.samlLoginUrl);

    window.location.replace(environment.samlLoginUrl);

    return false;
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'JSESSIONID=; Path=/api/authentication; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //console.log('auth.guard - can load - cookie: ', document.cookie);

    // Pasamos un array de las authorities posibles del usuario
    const authorities = route.data['requiredAuthorities'];

    //console.log('auth.guard - authorities: ', authorities);
    //console.log('auth.guard - isAuthenticated: ' + this.principalService.isAuthenticated())

    if (this.principalService.isAuthenticated()) {
      if (!authorities || authorities.length === 0) {
        return true;
      } else if (this.principalService.hasAnyAuthorityCheck(authorities)) {
        return true;
      }
    }

    if (window.location.pathname.indexOf('/callbackSaml') === 0 ) {
      //console.log('auth.guard - /callbackSaml en pathname');
      return this.router.navigate(['/callbackSaml']);
    } else {
      //console.log('auth.guard - NO /callbackSaml en pathname');
    }
    
    //console.log('auth.guard - samlLoginUrl: ' + environment.samlLoginUrl);

    window.location.replace(environment.samlLoginUrl);

    return false;
  }
}
